// src/services/supportApi.js
// Cliente del módulo Atención a Clientes — endpoints staff.
import api from './api';

export const inboxList   = (params = {}) => api.get('/support/inbox', { params }).then(r => r.data);
export const inboxDetail = (id)         => api.get(`/support/inbox/${id}`).then(r => r.data);

/** Envía mensaje del agente. files: array de File nativos (opcional). */
export const sendAgent = (id, { text = '', files = [] }) => {
    const form = new FormData();
    if (text) form.append('text', text);
    files.forEach(f => form.append('files', f));
    return api.post(`/support/inbox/${id}/messages`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data);
};

export const closeConv  = (id) => api.patch(`/support/inbox/${id}/close`).then(r => r.data);
export const reopenConv = (id) => api.patch(`/support/inbox/${id}/reopen`).then(r => r.data);

/** Escala el ticket subyacente al depto "Base de Datos Présico y sus Marcas".
 *  La conv del cliente se cierra con mensaje fijo y el ticket cambia de depto. */
export const escalateToTech = (id, note) => api.post(`/support/inbox/${id}/escalate-tech`, { note }).then(r => r.data);

/** URL del adjunto autenticado. Para `<img src>` no funciona directo (no manda
 *  Authorization), por eso usamos blob URL desde el componente. */
export const supportAttachmentUrl = (msgId, idx) =>
    `${api.defaults.baseURL}/support/messages/${msgId}/attachments/${idx}`;

export const getBotStatus = ()         => api.get('/support/bot-status').then(r => r.data);
export const setBotStatus = (enabled)  => api.patch('/support/bot-status', { enabled }).then(r => r.data);

/** Total de mensajes no leídos por staff en todas las convs abiertas. Sirve
 *  para el badge global del Topbar. */
export const getUnreadCount = ()       => api.get('/support/unread-count').then(r => r.data);

// ── UI/UX Sprint — endpoints nuevos staff-only ───────────────────────────────
export const inboxMetrics  = ()        => api.get('/support/inbox/metrics').then(r => r.data);
export const clientContext = (id)      => api.get(`/support/inbox/${id}/client-context`).then(r => r.data);
export const takeConv      = (id)      => api.post(`/support/inbox/${id}/take`).then(r => r.data);
export const transferConv  = (id, toUser) => api.post(`/support/inbox/${id}/transfer`, { toUser }).then(r => r.data);
/** Snooze: { minutes } o { until: ISO }. Sin args = despertar ahora. */
export const snoozeConv    = (id, opts = {}) => api.post(`/support/inbox/${id}/snooze`, opts).then(r => r.data);
/** Lista de agentes del depto Atención a Clientes (para dropdown de transferir). */
export const listSupportAgents = () =>
    api.get('/users', { params: { role: 'all', limit: 200 } })
        .then(r => Array.isArray(r.data) ? r.data : (r.data?.items || []));
